/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AddWhite, EditIcon, SearchIcon, ToggleOffIcon, ToggleOnIcon, TrashIcon } from '../../../assets/icons';
import { Constants, getUpdatedState, Globals } from '../../../utils';
import { Input, Modal, Pagination } from '../../../components';
import { UserService } from '../../../services';
import ModalCreateOwner from './modal-create-owner';

const Owners = ({ tabs }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [modalKey, setModalKey] = useState(0);
  const { data, deleteItem, filters, goToPage, onChange, pagination, reload, search, updateStatus } = useFetchTable();

  const openCreateModal = () => {
    setEditingItem(null);
    setModalKey(k => k + 1);
    setIsModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setModalKey(k => k + 1);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setEditingItem(null);
    setIsModalOpen(false);
  };

  return (
    <main className="w-full">
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalCreateOwner
          key={modalKey}
          initialData={editingItem}
          onClose={closeModal}
          onSuccess={reload}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="grid grid-cols-[2fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Buscar nombre, CI o RIF"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      {tabs}

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Registro de Propietarios</p>

          <button onClick={openCreateModal} className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold">
            <img src={AddWhite} className="w-4 h-4" alt="" />
            Nuevo
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th className="!pl-4">Nombre</th>
                <th>C.I. - Rif</th>
                <th>Correo electrónico</th>
                <th>Teléfono</th>
                <th>Dirección</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <div className="!pl-4">{item.person?.name}</div>
                  </td>
                  <td>{item.person?.document}</td>
                  <td>{item.email}</td>
                  <td>{item.person?.phone}</td>
                  <td>{item.person?.address_house}</td>
                  <td>
                    <div className="flex items-center gap-3 pr-4">
                      {item.status === Constants.USER.STATUS.SERVICE_OFF ? (
                        <img
                          key={`${item.id}-on`}
                          src={ToggleOnIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.USER.STATUS.DISABLED)}
                          alt=""
                        />
                      ) : (
                        <img
                          key={`${item.id}-off`}
                          src={ToggleOffIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.USER.STATUS.SERVICE_OFF)}
                          alt=""
                        />
                      )}
                      <img
                        src={EditIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => openEditModal(item)}
                        alt=""
                      />
                      <img
                        src={TrashIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => deleteItem(item.id)}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    level_id: Constants.LEVELS.OWNER,
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await UserService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const deleteItem = async (id) => {
    Globals.confirm('¿Está seguro de que desea eliminar este propietario?', async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await UserService.admin.destroy(id);
        toast.success('Propietario eliminado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const updateStatus = async (id, status) => {
    const statusText = status === Constants.USER.STATUS.SERVICE_OFF ? 'activar' : 'desactivar';
    Globals.confirm(`¿Está seguro de que desea ${statusText} este usuario?`, async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await UserService.admin.updateStatus({ id, status });
        toast.success('Usuario actualizado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    deleteItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    updateStatus,
  }
}

export default Owners;